import * as React from "react";
import { Props } from "../../types/global";

// declare type ManagePaymentState = {
// }
export default class ManagePayment extends React.Component<Props> {
    render() {
        return "manage payments";
    }
}